import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterManagementSettingsRoute: InvariantJiraRoute = {
	exact: true,
	name: 'helpcenter-management-settings',
	path: '/jira/helpcenter-management/:helpcenterId/settings',
};
